var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9781BC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,274.1c-10.9,0-19.7,8.8-19.7,19.7c0,10.9,8.8,19.7,19.7,19.7c10.9,0,19.7-8.8,19.7-19.7 C275.7,282.9,266.9,274.1,256,274.1L256,274.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.9,278.6l30.8-21.8l-30.3-51.7l-34.6,15.4c-8-6.4-17-11.2-26.8-14.9l-3.8-36.8h-60.6l-3.8,36.8 c-9.8,3.7-18.8,8.7-26.8,15.1l-34.6-15.5l-30.3,51.6l30.8,21.8c-1.6,10-1.6,20.4,0,30.4l-30.8,21.8l30.3,51.7l34.6-15.4 c8,6.4,17,12,26.8,15.7l3.8,37.6h60.6l3.8-37.6c9.8-3.7,18.8-9,26.8-15.5l34.6,15.3l30.3-51.7l-30.8-21.8 C351.7,304.1,353.7,293.8,350.9,278.6L350.9,278.6z M256,345.6c-28.5,0-51.7-23.2-51.7-51.8c0-28.6,23.2-51.8,51.7-51.8 s51.7,23.2,51.7,51.8S284.5,345.6,256,345.6L256,345.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,316.3c-0.5-6-0.8-12.1-0.8-18.2c0-74.4,39.8-145,103.5-183.4l15.2,25.3 c-55.8,33.7-89.2,92.8-89.2,158.1c0,5.2,0.2,10.5,0.7,15.7L43.6,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,512c-28.7,0-56.6-5.6-82.9-16.8l11.5-27.2c22.6,9.6,46.6,14.4,71.4,14.4c24.8,0,48.9-4.9,71.5-14.5 l11.5,27.2C312.7,506.3,284.8,512,256,512L256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.4,316.3l-29.4-2.5c0.4-5.2,0.7-10.5,0.7-15.7c0-65.3-33.3-124.4-89.2-158.1l15.2-25.3 c63.7,38.4,103.5,109,103.5,183.4C469.2,304.2,468.9,310.3,468.4,316.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 256,
    cy: 45.4,
    rx: 45.4,
    ry: 45.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 53,
    cy: 451.6,
    rx: 45.4,
    ry: 45.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 459,
    cy: 451.6,
    rx: 45.4,
    ry: 45.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpIntegration);
export default __webpack_public_path__ + "static/media/erp-integration.bb33666d6cb8189afaa177fa6826addd.svg";
export { ForwardRef as ReactComponent };